const getGeoData = async (remote) => {
  try {
    const response = await remote('getGeoDataFromAPI', null, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }, true);

    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    return null;
  }
};

export { getGeoData };
